import { z } from "zod";
/**
 * The closed runtime-provider vocabulary (multi-runtime M1; mirrored by the DB
 * CHECK constraint from migration 094). It lives in contracts — not the api —
 * so the model catalog, entitlement keys and the web can name providers
 * without importing server code. Adding a provider is a code change plus a
 * migration, never a config value; the api's runtime/registry.ts re-exports
 * these names so its consumers keep one import site.
 */
export const RUNTIME_PROVIDERS = ["anthropic", "openrouter", "foundry"];
export const RuntimeProviderSchema = z.enum(RUNTIME_PROVIDERS);
export function isRuntimeProvider(value) {
    return typeof value === "string" && RUNTIME_PROVIDERS.includes(value);
}
/**
 * Why a `<provider>/<model>` profile cannot run HERE, NOW, for THIS subject
 * (Template Strategy V2 §7; the api's selection-time evaluator emits these and
 * the web renders one plain sentence per code — never the raw code). Closed
 * vocabulary: policy codes are permission, installation codes are
 * operational, the rest are capability facts.
 */
export const PROFILE_UNAVAILABLE_CODES = [
    "provider_not_installed",
    "reservations_paused",
    "provider_not_allowed",
    "model_not_served",
    "model_not_allowed",
    "tool_not_allowed",
    "mcp_not_allowed",
    "required_capability_missing",
    "approval_mode_unsupported",
    "mcp_server_not_in_library",
    "skills_unsupported",
];
export const ProfileUnavailableCodeSchema = z.enum(PROFILE_UNAVAILABLE_CODES);
/**
 * A run's runner: who executes it. `anthropic` is Claude Managed Agents (the hosted reference),
 * `loop` the TypeScript loop in the server, `service` Agent Framework in the ACA sandbox behind
 * the server's own /v1. The model id's provider picks the engine id; the runner is a fact of
 * each run, recorded at launch as `runs.engine_target` and read by every later operation
 * (the service-routing plan §3.3), never re-derived from the deployment's routing table.
 * Lives here, beside the providers, so the wire schemas can name it without a module cycle.
 */
export const ENGINE_TARGETS = ["anthropic", "service", "loop"];
//# sourceMappingURL=runtime.js.map